import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { Osusume, OsusumeItem } from '@/models/OsusumeDetail';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';


export class OsusumeDetailService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();
    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getTokuten(form: any, id?: number) {
        const path = id ?
            `${this.baseAPI}/tokuten/${id}` :
            `${this.baseAPI}/tokuten?q=kyotenCd=${form.kyotenCd},groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getTokuten');
            return;
        }
    }

    public async editOsusume(data: OsusumeItem) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/tokuten/`, { ...data });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editOsusume');
            return;
        }
    }

    public async deleteOsusume(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/tokuten/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteOsusume');
            return;
        }
    }

    public async saveOsusume(data: any[], base: any) {
        const q = `groupCd=${base.groupCd},shatenCd=${base.shatenCd},kyotenCd=${base.kyotenCd}`;
        const { result, error } = await this.commonService.put(`${this.baseAPI}/tokuten-order-display?q=${q}`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveOsusume');
            return;
        }
    }
    
    public async cloneData(data: any[]) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/tokuten-clone`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async getShowFlag(form: any) {
        let path = `${this.baseAPI}/displayoption?q=kyotenCd=${form.kyotenCd}`;
        path += `,groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getShowFlag');
            return;
        }
    }

    public async saveShowOsusume(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/displayoption`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }


}
